/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowLoopLeft2 = createReactComponent("outline", "arrow-loop-left-2", "IconArrowLoopLeft2", [["path", { "d": "M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13", "key": "svg-0" }], ["path", { "d": "M8 16l-4 -4l4 -4", "key": "svg-1" }]]);

export { IconArrowLoopLeft2 as default };
//# sourceMappingURL=IconArrowLoopLeft2.mjs.map
